import { Box, Chip, Typography } from "@material-ui/core";
import { format, parseISO, subDays, subMonths } from "date-fns";

const formatDateDisplay = date => format(parseISO(date), "dd/MM/yyyy");
const formatDateQuery = date => format(date, "yyyy-MM-dd");

// Função para obter os períodos com datas atualizadas
const getPeriodEntries = () => {
  const today = new Date();
  const yesterday = subDays(today, 1);

  return [
    {
      name: "Hoje",
      startDate: formatDateQuery(today),
      endDate: formatDateQuery(today)
    },
    {
      name: "Ontem",
      startDate: formatDateQuery(yesterday),
      endDate: formatDateQuery(yesterday)
    },
    {
      name: "Último mês",
      startDate: formatDateQuery(subMonths(today, 1)),
      endDate: formatDateQuery(today)
    },
    {
      name: "Últimos 15 dias",
      startDate: formatDateQuery(subDays(today, 15)),
      endDate: formatDateQuery(today)
    },
    {
      name: "Últimos 7 dias",
      startDate: formatDateQuery(subDays(today, 7)),
      endDate: formatDateQuery(today)
    }
  ];
};

const groupByLabels = {
  product: "Agrupado por produto",
  reason: "Agrupado por motivo"
};

const ActiveFilters = ({
  params,
  reasons,
  categories,
  subcategories,
  onChange
}) => {
  const getPeriodLabel = () => {
    if (!params?.startDate || !params?.endDate) return null;

    // Obtém os períodos com datas atualizadas
    const periodEntries = getPeriodEntries();

    const matchingPeriod = periodEntries.find(
      entry =>
        entry.startDate === params.startDate && entry.endDate === params.endDate
    );

    if (matchingPeriod) {
      return matchingPeriod.name;
    }

    return `${formatDateDisplay(params.startDate)} - ${formatDateDisplay(
      params.endDate
    )}`;
  };

  const getSelectedReasonNames = () => {
    if (!params?.reasonId || !reasons) return [];
    return reasons
      .filter(r => params.reasonId.includes(r.id))
      .map(r => ({ id: r.id, label: r.label }));
  };

  const getSelectedCategoryNames = () => {
    if (!params?.categoryId || !categories) return [];
    return categories
      .filter(c => params.categoryId.includes(c.id))
      .map(c => ({ id: c.id, label: c.label }));
  };

  const getSelectedSubcategoryNames = () => {
    if (!params?.subcategoryId || !subcategories) return [];
    return subcategories
      .filter(s => params.subcategoryId.includes(s.id))
      .map(s => ({ id: s.id, label: s.label }));
  };

  const handleRemovePeriod = () => {
    onChange({
      startDate: undefined,
      endDate: undefined,
      groupBy: undefined,
      page: 1
    });
  };

  const handleRemoveReason = reasonId => {
    const newReasons = params.reasonId.filter(id => id !== reasonId);
    onChange({
      reasonId: newReasons.length > 0 ? newReasons : undefined,
      page: 1
    });
  };

  const handleRemoveAllReasons = () => {
    onChange({
      reasonId: undefined,
      page: 1
    });
  };

  const handleRemoveCategory = categoryId => {
    const newCategories = params.categoryId.filter(id => id !== categoryId);
    onChange({
      categoryId: newCategories.length > 0 ? newCategories : undefined,
      page: 1
    });
  };

  const handleRemoveSubcategory = subcategoryId => {
    const newSubcategories = params.subcategoryId.filter(
      id => id !== subcategoryId
    );
    onChange({
      subcategoryId: newSubcategories.length > 0 ? newSubcategories : undefined,
      page: 1
    });
  };

  const handleRemoveGroupBy = groupByItem => {
    const newGroupBy = params.groupBy.filter(item => item !== groupByItem);
    onChange({
      groupBy: newGroupBy.length > 0 ? newGroupBy : undefined,
      page: 1
    });
  };

  const periodLabel = getPeriodLabel();
  const selectedReasons = getSelectedReasonNames();
  const selectedCategories = getSelectedCategoryNames();
  const selectedSubcategories = getSelectedSubcategoryNames();
  const groupByItems = params?.groupBy || [];

  const hasActiveFilters =
    periodLabel ||
    selectedReasons.length > 0 ||
    selectedCategories.length > 0 ||
    selectedSubcategories.length > 0 ||
    groupByItems.length > 0;

  if (!hasActiveFilters) return null;

  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      style={{ gap: "0.5rem", marginTop: "0.5rem", width: "100%" }}
    >
      <Typography
        variant="body2"
        style={{ color: "#666", marginRight: "0.25rem" }}
      >
        Filtros ativos:
      </Typography>

      {periodLabel && (
        <Chip
          label={`Período: ${periodLabel}`}
          size="small"
          onDelete={handleRemovePeriod}
          color="primary"
          variant="outlined"
        />
      )}

      {selectedReasons.length > 0 && (
        <>
          {selectedReasons.length <= 3 ? (
            selectedReasons.map(reason => (
              <Chip
                key={reason.id}
                label={reason.label}
                size="small"
                onDelete={() => handleRemoveReason(reason.id)}
                style={{ backgroundColor: "#e3f2fd" }}
              />
            ))
          ) : (
            <Chip
              label={`${selectedReasons.length} motivos selecionados`}
              size="small"
              onDelete={handleRemoveAllReasons}
              style={{ backgroundColor: "#e3f2fd" }}
            />
          )}
        </>
      )}

      {selectedCategories.map(category => (
        <Chip
          key={category.id}
          label={`Cat: ${category.label}`}
          size="small"
          onDelete={() => handleRemoveCategory(category.id)}
          style={{ backgroundColor: "#fff3e0" }}
        />
      ))}

      {selectedSubcategories.map(subcategory => (
        <Chip
          key={subcategory.id}
          label={`Subcat: ${subcategory.label}`}
          size="small"
          onDelete={() => handleRemoveSubcategory(subcategory.id)}
          style={{ backgroundColor: "#fce4ec" }}
        />
      ))}

      {groupByItems.map(item => (
        <Chip
          key={item}
          label={groupByLabels[item] || item}
          size="small"
          onDelete={() => handleRemoveGroupBy(item)}
          style={{ backgroundColor: "#e8f5e9" }}
        />
      ))}
    </Box>
  );
};

export default ActiveFilters;
